import Vue from "vue";
import yrCartScroller from './scroller';

// Vue.config.productionTip = false;
// Vue.config.devtools = true;
// Vue.config.silent = false;

var dataElement = jQuery('#yrcartdata'), cartdata;
if(dataElement.length > 0){
  cartdata = JSON.parse(jQuery(dataElement[0]).text());
  jQuery(dataElement[0]).remove();
}
const LS_COUNT_KEY = 'yr-cart-product-count';
const yrCart = new Vue({
  el: '#yrcart',
  delimiters: ['${', '}'],
  data: {
    cart: cartdata,
    loading: false,
  },
  computed:{
    isEmpty: function () {
      return jQuery.isArray(this.cart.products)
          ? this.cart.products.length === 0 : jQuery.isEmptyObject(this.cart.products)
    }
  },
  methods:{
    qtyClick: function(index, qty){
      let q;
      jQuery.each(this.cart.products, function (i, p) {
        if(i === index){
          q = p.quantity + qty;
          return false;
        }
      });
      if(q > 0){
        return this.setQty(index, q);
      }
    },
    setQty: function(index, qty){
      var params = {};
      jQuery.each(this.cart.products, function (index, p) {
        params[index] = p.quantity;
      });
      params[index] = qty;
      return this.send('/cart/update', {quantity: params}, 'post').then(this.setData);
    },
    removeAll: function(){
      var params = {};
      jQuery.each(this.cart.products, function (index, p) {
        params[index] = 0;
      });
      return this.send('/cart/update', {quantity: params}, 'post').then(this.setData);
    },
    getData: function () {
      return this.cart;
    },
    setData: function (data) {
      Object.assign(this.cart, data);
      localStorage.setItem(LS_COUNT_KEY, this.cart.count_product);
      this.$emit('update', data);
    },
    add: function(data){
      return new Promise((resolve, reject) => {
        this.send('/cart/add', data)
            .then(response => {
              this.load()
                  .then(() => resolve(response))
                  .catch(reason => reject(reason))
            })
            .catch(reason => reject(reason));
      })
    },
    load: function(){
      return this.send('/cart', {format: 'json'}).then(this.setData);
    },
    send: function(url, data, method){
      var self = this;
      method = method || 'get';
      return new Promise(function(resolve, reject){
        self.loading = true;
        self.$emit('sendstart');
        jQuery.ajax(url, {
          dataType: 'json',
          type: method.toUpperCase(),
          data,
          success: function (json) {
            if(json['data'] === 'error'){
              reject(json);
            }else{
              resolve(json);
            }
          },
          error: function(jqXHR, textStatus){
            reject(jqXHR);
          },
          complete: function () {
            self.loading = false;
            self.$emit('sendend');
          }
        });
      });
    },
    validate(){
      if(localStorage.getItem(LS_COUNT_KEY) != this.cart.count_product){
        this.load();
      }
    }
  },
  created: function(){
    setInterval(this.validate.bind(this), 500);
  },
  mounted: function(){
    jQuery(this.$el).removeClass('d-none');
    yrCartScroller.init(this.$el);
  }
});

export {
  yrCart
};
